
import axios from 'axios'
import router from '../router';
import store from '../store'
import { Message, MessageBox } from 'element-ui'  //导入element-ui组件库

const baseUrl = process.env.VUE_APP_BASE_API; // url接口地址

// 创建axios的对象
const instance = axios.create({
    // baseURL: "http://192.168.20.236:9001",  //配置固定域名
    baseURL: baseUrl,
    timeout: 5000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
    function (config) {
        config.headers['Package-Name'] = window.location.hostname.indexOf('yaojing') >= 0 ? 'com.banban.live' : 'com.yujianzk.live'
        config.headers['appid'] = sessionStorage.getItem("appid") || '';
        // config.headers.token = '123456' // 请求头添加token值
        // config.headers.info = 'lxy'  //请求头添加info值
        // const token = localStorage.getItem('token'); // 从本地存储获取 token
        // if (token) {
        //     config.headers.Authorization = `Bearer ${token}`; // 添加 token 到请求头
        // }
        return config
    },
    function (err) {
        return Promise.request(err)
    }
)

// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
    function (response) {
        const res = response
        if (res.data.resp_code == 0) {
            return Promise.resolve(res);
        } else if (res.data.repCode === '0000') {
            return Promise.resolve(res);
        } else if (res.data.resp_code == -9998) {
            return Promise.resolve(res);
        } else if (res.data.resp_code == -9999) {
            // 跳转到登录页
            router.push({ path: '/login' });
            // 可选择清除 token
            localStorage.removeItem('token');
            store.commit("RESET_STATE");
            Message.error(res.data.resp_msg);
        } else {
            Message.error(res.data.resp_msg);
        }
    },
    function (err) {
        Message.error('服务器异常');
        return Promise.request(err)
    }
)


// 封装get和post请求
export function get(url, params) {
    return instance.get(url, { params })
}

export function post(url, data) {
    return instance.post(url, data)
}

export default instance;